import { MatDialogRef } from '@angular/material/dialog';
import { FiDialogsContainerBase } from '@fi-shared/fi-dialogs/fi-dialogs-container-base';
import { Directive, Inject, InjectionToken, Injector, TemplateRef, ViewChild } from '@angular/core';
import { IFiDialogResultValue } from '@fi-shared/fi-dialogs/fi-dialogs';
import { takeUntil } from 'rxjs/operators';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';
import { Subject } from 'rxjs';
import { FiDialogsService } from '@fi-shared/fi-dialogs/fi-dialogs.service';

export const FI_DIALOGS_CONTENT_DATA = new InjectionToken<any>('FiDialogsContentData');

@Directive()
export class FiDialogsContentBase<TData, TRes> {
    @ViewChild('customActionButtons') customActionButtonsTemplateRef: TemplateRef<any>;

    constructor(
        protected dialogRef: MatDialogRef<FiDialogsContainerBase<TData, TRes>, IFiDialogResultValue<TRes>>,
        @Inject(FI_DIALOGS_CONTENT_DATA) public data: TData,
        protected injector: Injector,
    ) {
        if (dialogRef) {
            dialogRef.componentInstance.setContentInstance(this);
        }
    }

    getResult(): TRes {
        return undefined;
    }

    getYesButtonText() {
        // use additionalData.yesButtonText
        return undefined;
    }

    isYesButtonDisabled() {
        return false;
    }

    getNoButtonText() {
        // use additionalData.noButtonText
        return undefined;
    }

    isNoButtonHidden() {
        return false;
    }

    isYesButtonHidden() {
        return false;
    }

    //#region obsolete methods, use  getYesButtonClickPromise/getNoButtonClickPromise
    onYesButtonClick($event: MouseEvent): void {}
    onNoButtonClick($event: Event): void {}
    //#endregion

    /**
     * override this if we should show confirm etc "ok/done" button click
     */
    getYesButtonClickPromise(): Promise<{ canClose: boolean }> {
        return Promise.resolve({ canClose: true });
    }

    /**
     * override this if we should show confirm etc on "no/close" button click
     */
    getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return Promise.resolve({ canClose: true });
    }

    subscribeOnTransitionCloseDialog(fiDialogsService: FiDialogsService, ngOnDestroy$: Subject<void>) {
        fiDialogsService
            .onTransitionCloseDialog$()
            .pipe(takeUntil(ngOnDestroy$))
            .subscribe(() => {
                this.getNoButtonClickPromise().then((result: { canClose: boolean }) => {
                    if (result?.canClose) {
                        this.dialogRef.close({ reason: FiDialogCloseReason.NoButton });
                    }
                });
            });
    }
}
